import React from "react";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import ComponentHeader from "../Header/ComponentHeader";
import { primaryColor, secondaryColor } from "../../Util/Colors";
import { calculatePercentage } from "../../Helpers/CommonHelper";
import { useInView } from "react-intersection-observer";
import KeyFigureNew from "../Elements/KeyFigureNew";
import EmptySpace from "../Elements/EmptySpace";
import { periodToComma } from "../../Helpers/CommonHelper";
import {
  headingSmall,
  headingLarge,
  HeadingMunicipality,
  FiguresWrapper,
  heading48
} from "../../Util/StyleProps";

import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 2.0s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  border-radius: 1000px;
  padding: 24px 40px;
  text-align: center;
  font-family: 'Inter';
  font-weight: 700;
  width: fit-content;
  margin-bottom: 48px;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
      padding: 32px 48px;
  }
  .label{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;

const EmplomentExtentContainer = props => {
  const { data, sweden, blockColor, scroll } = props;

  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true
  });

  const lastYear = sweden.emplomentextent.year;
  const swedenMedium = sweden.emplomentextent.men_and_women_in_work;
  const swedenWomen = sweden.emplomentextent.women_in_work;
  const swedenMen = sweden.emplomentextent.men_in_work;

  // I Sverige har 79,1 procent av dem som är 16-65 år ett jobb. Det är 77,9 procent av kvinnorna som jobbar, och 80,3 procent av männen (2018).
  //  Så många har jobb
  //  I Sverige har 79,5 procent av dem som är 20-64 år jobb. 78,1 procent av kvinnorna har jobb och 80,8 av männen (2018).

  //  Och under den översta kommunala procenten ändrar vi till:
  //  har jobb

  const swedenString =
    "I Sverige har " +
    periodToComma(swedenMedium) +
    " procent av dem som är 20-64 år jobb. " +
    periodToComma(swedenWomen) +
    " procent av kvinnorna har jobb och " +
    periodToComma(swedenMen) +
    " av männen (" +
    lastYear +
    ").";

  let municipality1 = data[0];
  let municipality2 = data[1];
  // Accessibility
  const ariaLabel = municipality => {
    return municipality
      ? `I ${municipality.name} kommun har ${municipality.women_and_men_in_work} procent ett jobb. ${municipality.women_in_work}
       procent av kvinnorna och ${municipality.men_in_work} procent av männen (${
          municipality.year ? "år" + municipality.year : "årtal saknas"
        }).`
      : "";
  };

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M18.5383 61.7757C14.0767 61.4634 10.6728 60.3918 8.32666 58.5607C5.98055 56.7295 4.8075 54.192 4.8075 50.9482C4.8075 47.7859 6.17611 45.2029 8.91333 43.199C11.6506 41.1945 15.4508 39.9701 20.3142 39.5257C22.9508 39.2818 24.9144 38.7731 26.205 37.9998C27.4956 37.2265 28.1408 36.1709 28.1408 34.8331C28.1408 33.0509 27.3353 31.6865 25.7242 30.7398C24.1131 29.7937 21.4294 29.1048 17.6733 28.6732L18.0258 24.9232C22.5642 25.4443 26.015 26.5404 28.3783 28.2115C30.7417 29.8826 31.9233 32.0898 31.9233 34.8331C31.9233 37.1965 30.9297 39.1301 28.9425 40.634C26.9553 42.1384 24.1861 43.0295 20.635 43.3073C16.6089 43.6279 13.595 44.4248 11.5933 45.6982C9.59111 46.972 8.59 48.722 8.59 50.9482C8.59 53.0209 9.43166 54.6418 11.115 55.8107C12.7989 56.9795 15.3247 57.707 18.6925 57.9932L18.5383 61.7757ZM44.3142 59.8398L32.9042 48.4298L62.1025 19.2631C62.8375 18.5493 63.6592 18.2062 64.5675 18.234C65.4753 18.2618 66.2967 18.6048 67.0317 19.2631L73.4808 25.6598C74.2158 26.3948 74.5833 27.2357 74.5833 28.1823C74.5833 29.129 74.2158 29.9593 73.4808 30.6732L44.3142 59.8398ZM30.2692 64.9998C29.5169 65.1793 28.8547 64.9826 28.2825 64.4098C27.7097 63.837 27.5131 63.1748 27.6925 62.4232L30.0258 51.224L41.5 62.6982L30.2692 64.9998Z" fill="#0F0865"/>
        <path d="M44.3142 59.8398L32.9042 48.4298L62.1025 19.2631C62.8375 18.5493 63.6592 18.2062 64.5675 18.234C65.4753 18.2618 66.2967 18.6048 67.0317 19.2631L73.4808 25.6598C74.2158 26.3948 74.5833 27.2356 74.5833 28.1823C74.5833 29.129 74.2158 29.9593 73.4808 30.6732L44.3142 59.8398Z" fill="#1F44FF"/>
        </svg>
        <ComponentHeader heading={"Så många har jobb"} text={swedenString} />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                  marginBottom="24px"
                    aria-label={ariaLabel(municipality1)}
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <AnimatedDiv
                    inView={inView}
                   >
                    <div>{municipality1 ? Number(municipality1.men_and_women_in_work).toLocaleString('sv-SE') : 0} %</div>
                    <div className="label">har jobb</div>
                  </AnimatedDiv>
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={0.75}
                    iconName={"female"}
                    alt="Ikon kvinna"
                    size={heading48}
                    value={municipality1.women_in_work}
                    subText={"av kvinnor"}
                    unit={"%"}
                  />
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={0.75}
                    iconName={"male"}
                    alt="Ikon man"
                    size={heading48}
                    value={municipality1.men_in_work}
                    subText={"av män"}
                    unit={"%"}
                    marginBottom={"0px"}
                  />
                </SvgLayout>
              ) : (
                <div></div>
              )}
              {municipality2 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                  marginBottom="24px"
                    color={secondaryColor}
                    aria-label={ariaLabel(municipality2)}
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <AnimatedDiv
                    inView={inView}
                    style={{
                      color: secondaryColor,
                     }}
                  >
                    <div>{municipality2 ? Number(municipality2.men_and_women_in_work).toLocaleString('sv-SE') : 0} %</div>
                    <div className="label">har jobb</div>
                  </AnimatedDiv>
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={1.75}
                    iconName={"female"}
                    alt="Ikon kvinna"
                    color={secondaryColor}
                    size={heading48}
                    value={municipality2.women_in_work}
                    subText={"av kvinnor"}
                    unit={"%"}
                  />
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={1.75}
                    iconName={"male"}
                    alt="Ikon man"
                    color={secondaryColor}
                    size={heading48}
                    value={municipality2.men_in_work}
                    subText={"av män"}
                    unit={"%"}
                    marginBottom={"0px"}
                  />
                </SvgLayout>
              ) : (
                <SvgLayout width="50%">
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

EmplomentExtentContainer.defaultProps = {
  data: [],
  sweden: {}
};

export default EmplomentExtentContainer;


